import { useCallback, useState } from 'react';

// 동적 컴포넌트 생성 hook
const useRenderComponent = () => {
  const [Components, setComponents] = useState([]); // 동적 컴포넌트 목록

  // 컴포넌트 이름 매핑 (DB에서 오는 이름 → 실제 파일 이름)
  const componentNameMap = {
    'RelatedPolicy.jsx': 'RelatedBasisPolicy.jsx',
    'RelatedLinks.jsx': 'RelatedLink.jsx'
  };

  // 동적 컴포넌트 생성 함수
  const handleRenderComponents = useCallback(async componentNames => {
    for (const componentName of componentNames) {
      try {
        // 이름 매핑 적용
        const correctedName = componentNameMap[componentName] || componentName;
        const { default: LoadedComponent } = await import(`components/template/${correctedName}`);
        setComponents(prev => [...prev, LoadedComponent]);
      } catch (error) {
        console.error(`❌ 컴포넌트를 찾을 수 없습니다: ${componentName}`, error);
        // 파일이 없는 경우 건너뛰기
      }
    }
  }, []);

  // 컴포넌트 초기화 함수
  const resetComponents = useCallback(() => {
    setComponents([]);
  }, []);

  return {
    Components,
    handleRenderComponents,
    resetComponents
  };
};

export default useRenderComponent;
